import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getPlaceContacts(payload) {
    const params = getParamsFormObject(payload);
    const path = `/place-contacts${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getPlaceContactDetails(payload) {
    const { id, place } = payload;

    const path = `/place-contacts/${id}?place=${place}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addPlaceContacts(payload) {
    const path = '/place-contacts';

    const response = await axiosClient.post(path, payload);

    return response.data;
  },

  async editPlaceContact(payload) {
    const { id, place, result } = payload;

    const path = `/place-contacts/${id}?place=${place}`;

    await axiosClient.put(path, result);
  },

  async deletePlaceContact(payload) {
    const { id, place } = payload;

    const path = `/place-contacts/${id}?place=${place}`;

    await axiosClient.delete(path);
  },
};
